<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblRoleTilesMappingTitle}} :: {{data.type}} </span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <!-- <mat-toolbar>{{translations.lblSelectedRole}} : {{data.type}}</mat-toolbar> -->
        <!-- <span class="title dialog-title">Selected Role : {{data.type}} </span> -->
        <form [formGroup]="formGroup" class="user-actions" novalidate>
           <div class="card-container">
                <div class="card" *ngFor="let tile of filterTiles('OrderStatus')" [style.border-color]="tile.Background">
                    <div class="title" [style.background]="tile.Background"> 
                        <div style="margin-top:3px; float: left;display: inline-block;"> {{ tile.Title }} </div>
                        <div class="icon"> <img src="{{'../../../../assets/images/flags/' + tile.Icon }}" /></div>
                    </div>
                    <div class="content" [style.color]="tile.Background">{{ formatOrderCount(0, ',')}}</div>
                    <!-- <mat-progress-bar [style.color]="tile.Background" mode="determinate" [value]="tile.OrderCount"></mat-progress-bar> -->
                    <div class="w3-light-grey" style="background: lightgrey">
                      <div class="w3-green" [style.background]="tile.Background" [style.width]="((tile.OrderCount / tile.TotalCount) * 100) + '%'" style="height:2px;"></div>
                    </div>
                    <div class="footer">
                        <div style="float:left;display: inline;" [style.color]="tile.Background"> 
                             {{translations.lblDashboardVisibility}}
                        </div>
                       <mat-slide-toggle [id]="tile.MasterId" [(ngModel)]="tile.IsMapped"  [ngModelOptions]="{standalone: true}"> 
                           
                       </mat-slide-toggle>
                    </div>
                </div>
            </div>
             <div class="chart-container" *ngIf="filterTiles('Graph').length == 1">
                <div class="title" *ngFor="let tile of filterTiles('Graph')"> 
                    <div style="margin-top:3px; float: left;display: inline-block;width: 100%;" [style.color]="tile.Background"> 
                        <div style="float: left;">{{translations.lblDashboardVisibility}} </div>
                        <div style="float: right;"><mat-slide-toggle [id]="tile.MasterId" [(ngModel)]="tile.IsMapped"  [ngModelOptions]="{standalone: true}"></mat-slide-toggle></div>
                    </div>
                    <div class="icon"><img class="chart-image" src="{{'../../../../assets/images/flags/' + tile.Icon }}" /></div>
                </div>
             </div>
        </form>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
         <button mat-raised-button color="accent" aria-label="SAVE" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnClose}}
        </button>
    </div>
</div>     


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/dashboard-tiles-edit-form/dashboard-tiles-edit-form.component.html